import { schema } from "normalizr"
import importEntity from "./import"

export default new schema.Array(importEntity)
